import { AgGridVue } from "ag-grid-vue";
import "@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss";

import Vue from "vue";

import moduleDrilling from "../store/moduleDrilling.js";

import { BooleanCell } from "../../shared/components";
import drillSideView from "./components/drillSideView.vue";
import Datepicker from 'vuejs-datepicker';
import DrillActionsCellRenderer from "./components/DrillActionsCellRenderer.vue"
import MovedByEnum from "../MovedByEnum";

export default {
  components: {
    /* eslint-disable vue/no-unused-components */
    AgGridVue,
    Datepicker,
    DrillActionsCellRenderer,
    drillSideView,
    BooleanCell
  },
  data() {
    return {
      addNewDataSidebar: false,
      sidebarData: {},
      defaultColDef: {
        sortable: true,
        resizable: true,
        editable: false
      },
      movedByValues: MovedByEnum.definition,
      gridApi: null,
      gridOptions: {
        getRowNodeId: (data) => {
          return data.drillRigId;
        }
      },
      context: { componentParent: this },
      columnDefs: [
        {
          headerName: 'Actions',
          field: 'drillRigId',
          width: 250,
          editable: false,
          sortable: false,
          checkboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          headerCheckboxSelection: true,
          cellRendererFramework: Vue.extend(DrillActionsCellRenderer)
        },
        { 
          headerName: this.$t('Drilling.Drills.Code'),
          field: "code",
          filter: true,
          width: 165
        },
        { 
          headerName: this.$t('Drilling.Companies.Name'),
          field: "companyId",
          filter: true,
          width: 165,
          valueGetter: (params) => {
            const company = this.companies.find(c => c.companyId === params.data.companyId);
            if (company)
              return company.shortName;

            return "";
          }
        },
        {
          headerName: this.$t('Drilling.Drills.IsActive'),
          field: "isActive",
          width: 200,
          filter:'agTextColumnFilter',
          cellRendererFramework: "BooleanCell"
        },
        {
          headerName: this.$t('Drilling.Drills.IsAutomated'),
          field: "isAutomated",
          width: 200,
          filter:'agTextColumnFilter',
          cellRendererFramework: "BooleanCell"
        },
        { 
          headerName: this.$t('Drilling.Drills.MovedBy'),
          field: "movedBy",
          filter: true,
          width: 165,
          valueGetter: (params) => {
            const value = this.movedByValues.find(c => c.id === params.data.movedBy);
            if (value)
              return value.name;

            return "";
          }
        },
        { 
          headerName: this.$t('Drilling.Drills.DrillingCapacity'),
          field: "drillingCapacity",
          filter: true,
          width: 165
        },
        { 
          headerName: this.$t('Drilling.Drills.Length'),
          field: "length",
          filter: true,
          width: 165
        },
        { 
          headerName: this.$t('Drilling.Drills.Width'),
          field: "width",
          filter: true,
          width: 165
        },
        { 
          headerName: this.$t('Drilling.Drills.Height'),
          field: "height",
          filter: true,
          width: 165
        }
      ],
      components: {
        DrillActionsCellRenderer
      }
    };
  },

  computed: {
    drills() {
      return this.$store.state.drilling.drills;
    },
    companies() {
      return this.$store.state.drilling.companies;
    }
  },
  mounted() {
    this.gridApi = this.gridOptions.api;
  },
  created() {
    if (!moduleDrilling.isRegistered) {
      this.$store.registerModule("drilling", moduleDrilling);
      moduleDrilling.isRegistered = true;
    }

    this.$vs.loading();
    this.$store.dispatch("drilling/fetchAllCompanies").then(() => {
      this.$refs.listCard.refreshcard();
    }).finally(() => {
      this.$vs.loading.close();
    })

  },
  methods: {
    getDrills() {
      this.$store.dispatch("drilling/fetchAllDrills")
        .finally(() => {
          this.$refs.listCard.removeRefreshAnimation()
        });
    },
    deleteData(id) {
      this.$store.dispatch("drilling/removeDrill", id)
        .then(() => {
          this.$notifyDeleteSuccess(this.$t("Drilling.Drills.DrillDeleted"));
          this.$refs.listCard.refreshcard();
        }).catch((error) => {
          if (error.response.status === 409) {
            this.$refs.listCard.refreshcard();
          }
        });
    },
    addNewData() {
      this.sidebarData = {};
      this.toggleDataSidebar(true);
    },
    editData(data) {
      this.sidebarData = data;
      this.toggleDataSidebar(true);
    },
    toggleDataSidebar(val = false) {
      this.addNewDataSidebar = val;
    },
    onUpdated(drill) {
      this.$notifySaveSuccess();

      this.toggleDataSidebar(false);
      const rowNode = this.gridApi.getRowNode(drill.drillRigId);
      if (rowNode) {
        rowNode.setData(drill);
      }

      this.gridApi.applyTransaction({ update: [drill] });
      this.$refs.listCard.refreshcard();
    },
    onInserted(drill) {
      this.$notifySaveSuccess();
      this.toggleDataSidebar(false);
      this.gridApi.applyTransaction({ update: [drill] });
      this.$refs.listCard.refreshcard();
    }
  }
};
